import ReactMarkdown from 'react-markdown'

interface WelcomeMessageBannerProps {
  content: string
  artistAvatar?: string
  className?: string
}

export function WelcomeMessageBanner({
  content,
  artistAvatar,
  className
}: WelcomeMessageBannerProps) {
  if (!content || !content.trim()) return null

  return (
    <div className={`flex justify-start mb-1 items-end gap-2 ${className || ''}`}>
      {/* Avatar */}
      {artistAvatar && (
        <div className="w-8 h-8 flex-shrink-0">
          <div className="w-8 h-8 rounded-full overflow-hidden bg-muted">
            <img 
              src={artistAvatar} 
              alt="Artist" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      )}
      
      {/* Message bubble - styled like artist message */}
      <div className="bg-muted rounded-[18px] rounded-bl-[8px] px-4 py-3 max-w-[280px]">
        <div className="text-[15px] leading-[20px] whitespace-pre-wrap break-words text-foreground">
          <ReactMarkdown
            components={{
              a: ({ node, ...props }) => (
                <a {...props} className="text-primary underline" />
              ),
              p: ({ node, ...props }) => (
                <p {...props} className="whitespace-pre-wrap" />
              ),
              strong: ({ node, ...props }) => (
                <strong {...props} className="font-semibold" />
              ),
              em: ({ node, ...props }) => (
                <em {...props} className="italic" />
              )
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  )
}

